export default "__VITE_ASSET__DlWImk2J__"